export const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY
export const firebaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN
export const firebaseProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID
export const firebaseStorageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
export const firebaseMessagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
export const firebaseAppId = process.env.REACT_APP_FIREBASE_APP_ID